import { Row, Col, Button, Steps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Step } = Steps;

const Header = ({
  form,
  reservation,
  currentStep,
  setCurrentStep,
  setStartAdmission,
  setPatientToAdmission
}) => {
  const { t } = useTranslation();

  const handleBackButton = () => {
    if (currentStep === 0) {
      form.resetFields();
      setPatientToAdmission();
      setStartAdmission(false);
    } else if (currentStep === 1) {
      setCurrentStep(0);
      form.resetFields();
    } else if (currentStep === 2) {
      setCurrentStep(1);
    } else {
      setCurrentStep(2);
    }
  };

  const handleNextButton = () => {
    if (currentStep === 2) {
      setCurrentStep(3);
    }
  };

  return (
    <Row justify="center">
      <Col lg={24} xs={24} className="admission-settings__header pt-20 pb-10">
        <Row justify="center">
          <Col lg={22} xs={22}>
            <Row justify="space-between">
              <Col className="direction-button-wrapper">
                <Button
                  onClick={handleBackButton}
                  className="cmt-button primary non-outline"
                  type="primary"
                >
                  <i className="icon-system-chevron-left" />
                  {
                    currentStep === 0 ? 'Volver' : 'Volver a paso anterior'
                  }
                </Button>
              </Col>
              {
                currentStep === 2 &&
                <Col className="direction-button-wrapper">
                  <Button
                    onClick={handleNextButton}
                    className="cmt-button primary non-outline"
                    type="primary"
                  >
                    Saltar paso
                    <i className="icon-system-chevron-right ml-5" />
                  </Button>
                </Col>
              }
              <Col lg={24} xs={24}>
                <h1 className='text-center'>
                  {t('admissionPage.header.title')} {reservation && reservation.number}
                </h1>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col lg={15} xs={22} className="admission-settings__steps mt-20">
        <Steps
          current={currentStep}
          progressDot
          direction="horizontal"
          responsive={false}
          className="step-wrapper"
        >
          <Step title="1" description={t('admissionPage.header.patientData')} />
          <Step title="2" description={t('admissionPage.header.services')} />
          <Step title="3" description="Consentimientos" />
          <Step title="4" description="Ingreso" />
        </Steps>
      </Col>
    </Row>
  );
};

export default Header;
